import { useState, useMemo } from 'react';
import { useRecordContext } from 'react-admin';
import { BLACKLISTED_STATUS } from '@/pages/Candidate/view/tabs/ChecksTab/constants';
import { FCRAWorker } from '@/types/turn-api';

const useController = () => {
  const record: FCRAWorker.Details = useRecordContext();
  const [showRequestCounty, setShowRequestCounty] = useState(false);
  const [showRequestMVR, setShowRequestMVR] = useState(false);

  const toggleRequestCounty = () => setShowRequestCounty((prev) => !prev);

  const toggleRequestMVR = () => setShowRequestMVR((prev) => !prev);

  const isFormOpen = useMemo(() => showRequestCounty || showRequestMVR, [showRequestCounty, showRequestMVR]);

  const cannotRequestMVR = useMemo(
    () => BLACKLISTED_STATUS?.includes(record?.profile_status),
    [record?.profile_status]
  );

  return {
    isFormOpen,
    cannotRequestMVR,
    showRequestCounty,
    showRequestMVR,
    toggleRequestCounty,
    toggleRequestMVR,
  };
};

export default useController;
